import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keyword" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'SilverTau - Silver and Platinum collectible bullion coins.',
  description: 'Collectible and investment bullion coins',
  keywords: 'coins, precious metals, verifiers',
};

export default Meta;
